import styled from 'styled-components';

export const Banner = styled.div`
  position: fixed;
  left: 50%;
  top: 30px;
  padding: 5px;
  width: 220px;
  margin-left: -110px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  background: #000;
  z-index: 99999;
  font-family: 'Courier New', Courier, monospace;
`;
